import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/Motion";
import { ViewerProvider } from "@/components/site/Viewer";
import { ProtectMedia } from "@/components/site/Protect";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import Video from "@/pages/Video";
import FrameVisualizer from "@/pages/FrameVisualizer";
import PhotoPage from "@/pages/PhotoPage";
import { Blog, BlogPost } from "@/pages/Blog";
import { About, Contact, InstagramPage } from "@/pages/Static";
import { AuthProvider, AdminDashboard, AdminLogin } from "@/admin/AdminApp";

const SiteLayout = () => {
  const { pathname } = useLocation();
  return (
    <ViewerProvider>
      <ProtectMedia />
      <Header />
      <main key={pathname}><Outlet /></main>
      <Footer />
    </ViewerProvider>
  );
};

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/gallery/:category" element={<Gallery />} />
              <Route path="/photo/:slug" element={<PhotoPage />} />
              <Route path="/video" element={<Video />} />
              <Route path="/frame-visualizer" element={<FrameVisualizer />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/instagram" element={<InstagramPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
